import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { IntroNamePage } from './intro-name';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    IntroNamePage,
  ],
  imports: [
    IonicPageModule.forChild(IntroNamePage),
    PipesModule,
    DirectivesModule,

  ],
})
export class IntroNamePageModule {}



// WEBPACK FOOTER //
// ./src/pages/intro-name/intro-name.module.ts